import { render, staticRenderFns } from "./MainPagePanel4.vue?vue&type=template&id=d6cde046&scoped=true&"
import script from "./MainPagePanel4.vue?vue&type=script&lang=js&"
export * from "./MainPagePanel4.vue?vue&type=script&lang=js&"
import style0 from "./MainPagePanel4.vue?vue&type=style&index=0&id=d6cde046&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6cde046",
  null
  
)

export default component.exports